import { FilterService } from '@alpha-core/platform-ui/services/filter.service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { userService } from '../../services/user-service';

@Injectable({ providedIn: 'root' })
export class CasesRedirectResolver implements Resolve<void> {
    private readonly router = inject(Router);
    private readonly filterService = inject(FilterService);
    private readonly userService = inject(userService);

    async resolve(route: ActivatedRouteSnapshot): Promise<void> {
        const projectId = route.queryParams['projectId'];
        const defaultTask = (await lastValueFrom(this.userService.getUserMetadata()))?.metadata?.[0]?.metadata
            ?.adminDefaultTask?.[projectId];
        const defaultTaskKey = defaultTask?.key || 'tasks';

        this.filterService.inboxType = defaultTaskKey;
        this.filterService.savedFilter = defaultTask?.filterObject ? true : false;

        this.router.navigate(['/home/cases', defaultTaskKey], {
            queryParams: { projectId },
            replaceUrl: true,
        });
    }
}
